module.exports = __webpack_public_path__ + "static/media/drumstick-bite.34a0b906.svg";